<script lang="ts" setup>
  import type { CCardItemData } from '@/components/common/CCardItem/CCardItem.types'
  import type { ImageProviderSource, ImgLoading } from '@/types/media'

  withDefaults(
    defineProps<{
      id: string
      alignment?: 'left' | 'centre' | 'right'
      backgroundColor?: string
      darkMode?: boolean
      items: CCardItemData[]
      loading: ImgLoading
      preload?: boolean
      provider?: ImageProviderSource
    }>(),
    {
      alignment: 'left',
      backgroundColor: 'inherit',
      darkMode: false,
      loading: 'lazy',
      preload: false,
      provider: 'contentful'
    }
  )
</script>

<template>
  <div class="c-card-grid">
    <CCardItem
      v-for="item in items"
      :key="item.id"
      :alignment
      :aspect-ratio="{
        desktop: { denominator: 4, numerator: 5 },
        mobile: { denominator: 4, numerator: 5 }
      }"
      :dark-mode="darkMode"
      :data="item"
      :loading
      :preload
      :provider
      primary-button-variant="primary"
      secondary-button-variant="secondary"
    />
  </div>
</template>

<style lang="scss" scoped>
  .c-card-grid {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 16px;
    width: 100%;
    padding: 0 16px;
    background-color: v-bind(backgroundColor);
    overflow: hidden;
    box-sizing: border-box;

    @media (min-width: 480px) {
      grid-template-columns: repeat(2, 1fr);
      padding: 0 24px;
    }

    @include screenSmAndUp {
      grid-template-columns: repeat(2, 1fr);
      gap: 16px;
      padding: 0 24px;
    }

    @include screenMdAndUp {
      grid-template-columns: repeat(2, 1fr);
      gap: 24px;
      padding: 0 24px;
    }

    @include screenLgAndUp {
      grid-template-columns: repeat(3, 1fr);
      gap: 24px;
      padding: 0 24px;
    }

    @include screenXlAndUp {
      grid-template-columns: repeat(4, 1fr);
      gap: 32px;
      padding: 0 24px;
    }
  }
</style>
